<template>
 <div>
   <el-table :show-header=false :data="tableData">
     <el-table-column>
       <template slot-scope="scope">
         <el-form>
           <el-form-item>
             <!--时间-->
             <el-row>
               <el-col :span="2">
                 <span class="iconfont" style="color:#FF8C00;">&#xe610;</span>
               </el-col>
               <el-col :span="4">
                 <span>时间:</span>
               </el-col>
               <el-col :span="18">
                 <span>{{scope.row.occurTime}}</span>
               </el-col>
             </el-row>
             <el-row>
               <!--设备名称-->
               <el-col :span="2">
                 <span class="iconfont" style="color: #0000FF">&#xe611;</span>
               </el-col>
               <el-col :span="10">
                 <span>{{scope.row.deviceTypeName}}</span>
               </el-col>
               <!--事件类型-->
               <el-col :span="2">
                 <span class="iconfont" style="color: #EE0000">&#xe69f;</span>
               </el-col>
               <el-col :span="10">
                 <span>{{scope.row.eventType}}</span>
               </el-col>
             </el-row>
             <!--设备编号-->
             <el-row>
               <el-col :span="2">
                 <span class="iconfont" style="color: #999999">&#xe635;</span>
               </el-col>
               <el-col :span="22">
                 <span>{{scope.row.deviceCode}}</span>
               </el-col>
             </el-row>
             <!--位置-->
             <el-row>
               <el-col :span="2">
                 <span class="iconfont" style="color: #009999">&#xe60f;</span>
               </el-col>
               <el-col :span="22">
                 <span>{{scope.row.occurPlace}}</span>
               </el-col>
             </el-row>
           </el-form-item>
         </el-form>
       </template>
     </el-table-column>
   </el-table>
 </div>
</template>

<script>
  import { MessageBox } from 'mint-ui'
  import { Toast } from 'mint-ui';
  export default {
    name: 'AlarmRecord',
    data(){
      return {
        code:'',
        tableData:[]
      }
    },
    created () {
      this.code=this.getUrlParams().code
      console.log("code=",this.code)
      this.getList()
    },
    methods:{
      //获取code
      getUrlParams () {
        console.log("=====getUrlParams=====")
        var url = location.search
        var urlParams = {}
        if (url.indexOf('?') !== -1) {
          var str = url.substr(1)
          var strs = str.split('&')
          for (var i = 0; i < strs.length; i++) {
            urlParams[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
          }
        }
        return urlParams
      },
      getList(){
        this.axios.get('https://xf.automofang.com/api/v1/wxoa/queryAlarmRecord?code='+this.code).then((response) => {
          console.log("response.data:",response.data)
          console.log("tableData:",response.data.data)
          if(response.data.code==200){
            this.tableData=response.data.data
          }else{
            Toast({
              message: response.data.message,
            });
          }
        })
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/alarmRecord/AlarmRecord.vue